export const NAM_BANKS_AND_BRANCHES = [{
    id: 60, description: "Banco Atlántico", bankBranches: [{
        id: 9204, bankId: 60, branchName: "Maura", branchCode: "885001"
    }]
}
    , {
    id: 62, description: "Bank BIC Namibia", bankBranches: [{
        id: 9288, bankId: 62, branchName: "BANK BIC UNIVERSAL BRANCH", branchCode: "885001"
    }]
},
{
    id: 21, description: "Bank Windhoek", bankBranches: [{
        id: 5963, bankId: 21, branchName: "//AIGAMS", branchCode: "486272"
    },
    {
        id: 5939, bankId: 21, branchName: "ACB,CARDS & ELECTR BANK SERV", branchCode: "483772"
    },
    {
        id: 5954, bankId: 21, branchName: "AIRPORT ( WHK )", branchCode: "485372"
    },
    {
        id: 5956, bankId: 21, branchName: "AMINUS", branchCode: "485571"
    },
    {
        id: 5955, bankId: 21, branchName: "ARANOS", branchCode: "485471"
    },
    {
        id: 5964, bankId: 21, branchName: "CAPRICORN BRANCH", branchCode: "486372"
    },
    {
        id: 5930, bankId: 21, branchName: "CASH CENTRE", branchCode: "482872"
    },
    {
        id: 5926, bankId: 21, branchName: "CENTRAL-ADMIN BRANCH ( WHK )", branchCode: "482372"
    },
    {
        id: 5942, bankId: 21, branchName: "CORPORATE ( WHK )", branchCode: "484072"
    },
    {
        id: 9266, bankId: 21, branchName: "DIGITAL", branchCode: "483773"
    },
    {
        id: 5941, bankId: 21, branchName: "EENHANA", branchCode: "483973"
    },
    {
        id: 5953, bankId: 21, branchName: "ELECTRONIC BANKING SERVICES", branchCode: "485272"
    },
    {
        id: 5950, bankId: 21, branchName: "ESME FINANCE ( WHK )", branchCode: "484872"
    },
    {
        id: 5948, bankId: 21, branchName: "FUNDING ( WHK )", branchCode: "484672"
    },
    {
        id: 5965, bankId: 21, branchName: "GLOBAL CUSTODY", branchCode: "486472"
    },
    {
        id: 5913, bankId: 21, branchName: "GOBABIS", branchCode: "481172"
    },
    {
        id: 5927, bankId: 21, branchName: "GROOTFONTEIN", branchCode: "482473"
    },
    {
        id: 5945, bankId: 21, branchName: "HEAD OFFICE DEPARTMENTS", branchCode: "484372"
    },
    {
        id: 5938, bankId: 21, branchName: "HEAD OFFICE FINANCE", branchCode: "483672"
    },
    {
        id: 5934, bankId: 21, branchName: "IBS ( WHK )", branchCode: "483272"
    },
    {
        id: 5912, bankId: 21, branchName: "JOHANNESBURG", branchCode: "480105"
    },
    {
        id: 5914, bankId: 21, branchName: "KARASBURG", branchCode: "481271"
    },
    {
        id: 5925, bankId: 21, branchName: "KATIMA- MULILO", branchCode: "482273"
    },
    {
        id: 5931, bankId: 21, branchName: "KATUTURA ( WHK )", branchCode: "482972"
    },
    {
        id: 5915, bankId: 21, branchName: "KEETMANSHOOP", branchCode: "481371"
    },
    {
        id: 5962, bankId: 21, branchName: "KHOMASDAL", branchCode: "486172"
    },
    {
        id: 5924, bankId: 21, branchName: "KUDU (WINDHOEK)", branchCode: "482172"
    },
    {
        id: 5947, bankId: 21, branchName: "LEGAL BRANCH ( WHK )", branchCode: "484572"
    },
    {
        id: 5960, bankId: 21, branchName: "LUDERITZ", branchCode: "485971"
    },
    {
        id: 5940, bankId: 21, branchName: "MAERUA MALL AND AUSPANNPLATZ", branchCode: "483872"
    },
    {
        id: 5916, bankId: 21, branchName: "MARIENTAL", branchCode: "481471"
    },
    {
        id: 5936, bankId: 21, branchName: "MICRO FINANCE AND SME", branchCode: "483472"
    },
    {
        id: 5958, bankId: 21, branchName: "NKURENKURU", branchCode: "485773"
    },
    {
        id: 5952, bankId: 21, branchName: "NOORDOEWER", branchCode: "485171"
    },
    {
        id: 5929, bankId: 21, branchName: "OKAHANDJA", branchCode: "482773"
    },
    {
        id: 9267, bankId: 21, branchName: "OKAHAO", branchCode: "484174"
    },
    {
        id: 5949, bankId: 21, branchName: "OKAKARARA", branchCode: "484773"
    },
    {
        id: 5961, bankId: 21, branchName: "OKAUKUEJO", branchCode: "486073"
    },
    {
        id: 9268, bankId: 21, branchName: "OLD MUTUAL", branchCode: "484772"
    },
    {
        id: 5959, bankId: 21, branchName: "OMARURU", branchCode: "485873"
    },
    {
        id: 5967, bankId: 21, branchName: "OMUTHIYA", branchCode: "486571"
    },
    {
        id: 5935, bankId: 21, branchName: "ONDANGWA", branchCode: "483373"
    },
    {
        id: 5957, bankId: 21, branchName: "ONGWEDIVA", branchCode: "485673"
    },
    {
        id: 5944, bankId: 21, branchName: "OPUWO", branchCode: "484273"
    },
    {
        id: 5917, bankId: 21, branchName: "ORANJEMUND", branchCode: "481571"
    },
    {
        id: 5928, bankId: 21, branchName: "OSHAKATI", branchCode: "482673"
    },
    {
        id: 5951, bankId: 21, branchName: "OSHAKATI - NORTH", branchCode: "484973"
    },
    {
        id: 9202, bankId: 21, branchName: "Oshifo-Ruacana", branchCode: "486672"
    },
    {
        id: 5966, bankId: 21, branchName: "OSHIKANGO", branchCode: "486473"
    },
    {
        id: 5943, bankId: 21, branchName: "OTAPI", branchCode: "484173"
    },
    {
        id: 5918, bankId: 21, branchName: "OTJIWARONGO", branchCode: "481573"
    },
    {
        id: 5919, bankId: 21, branchName: "OUTJO", branchCode: "481673"
    },
    {
        id: 9201, bankId: 21, branchName: "PRIVATE WEALTH BANK WINDHOEK", branchCode: "484172"
    },
    {
        id: 5946, bankId: 21, branchName: "PROPERTY FINANCE ( WHK )", branchCode: "484472"
    },
    {
        id: 5968, bankId: 21, branchName: "REHOBOTH", branchCode: "486572"
    },
    {
        id: 5933, bankId: 21, branchName: "RUNDU", branchCode: "483173"
    },
    {
        id: 5920, bankId: 21, branchName: "SWAKOPMUND", branchCode: "481772"
    },
    {
        id: 6184, bankId: 21, branchName: "THE GROVE", branchCode: "483871"
    },
    {
        id: 5937, bankId: 21, branchName: "TREASURY ( WHK )", branchCode: "483572"
    },
    {
        id: 5932, bankId: 21, branchName: "TSUMEB", branchCode: "483073"
    },
    {
        id: 5923, bankId: 21, branchName: "VEHICLE & ASSET", branchCode: "482072"
    },
    {
        id: 5921, bankId: 21, branchName: "WALVIS BAAI", branchCode: "481872"
    },
    {
        id: 5922, bankId: 21, branchName: "WINDHOEK", branchCode: "481972"
    }]
},
{
    id: 42, description: "First National Bank Namibia", bankBranches: [{
        id: 3745, bankId: 42, branchName: "ALCO", branchCode: "280579"
    },
    {
        id: 3772, bankId: 42, branchName: "ALOE PROPERTIES", branchCode: "281074"
    },
    {
        id: 3756, bankId: 42, branchName: "ARANOS NAMIBIA - 530", branchCode: "280771"
    },
    {
        id: 3738, bankId: 42, branchName: "ATM SERVICE CENTRE", branchCode: "280572"
    },
    {
        id: 9261, bankId: 42, branchName: "AUSSENKEHR BRANCH", branchCode: "289977"
    },
    {
        id: 3714, bankId: 42, branchName: "AUSSPANNPLATZ NAMIBIA - 551", branchCode: "280272"
    },
    {
        id: 9195, bankId: 42, branchName: "BANK RMB CORPORATE", branchCode: "289180"
    },
    {
        id: 9246, bankId: 42, branchName: "BANKING APP CHANNEL", branchCode: "283273"
    },
    {
        id: 3715, bankId: 42, branchName: "BUSINESS DEVELOPMENT DEPT", branchCode: "280273"
    },
    {
        id: 3708, bankId: 42, branchName: "CARD ISSUING NAMIBIA", branchCode: "280179"
    },
    {
        id: 3717, bankId: 42, branchName: "CASH SERVICE CENTRE 582", branchCode: "280275"
    },
    {
        id: 3746, bankId: 42, branchName: "CELLPHONE BANKING", branchCode: "280580"
    },
    {
        id: 3815, bankId: 42, branchName: "CONTACT CENTRE FNB NAMIBIA", branchCode: "289071"
    },
    {
        id: 3816, bankId: 42, branchName: "CREDIT SUPPORT", branchCode: "289171"
    },
    {
        id: 3704, bankId: 42, branchName: "DEBIT CARD NAMIBIA 581", branchCode: "280175"
    },
    {
        id: 3810, bankId: 42, branchName: "DEBTOR FINANCE NAMIBIA", branchCode: "285175"
    },
    {
        id: 3788, bankId: 42, branchName: "DISTRIBUTION HEAD OFFICE", branchCode: "281573"
    },
    {
        id: 9259, bankId: 42, branchName: "E-BANK DIVISION", branchCode: "289975"
    },
    {
        id: 3792, bankId: 42, branchName: "EENHANA", branchCode: "281773"
    },
    {
        id: 3787, bankId: 42, branchName: "ELECTRONIC BANKING DEPARTMENT", branchCode: "281572"
    },
    {
        id: 3707, bankId: 42, branchName: "EMPLOYEE SHARE TRUST", branchCode: "280178"
    },
    {
        id: 9249, bankId: 42, branchName: "ERONGO CLUSTER", branchCode: "289272"
    },
    {
        id: 3818, bankId: 42, branchName: "E-WALLET NAMIBIA", branchCode: "289173"
    },
    {
        id: 3703, bankId: 42, branchName: "EXCLUSIVE BANKINGSUITE", branchCode: "280174"
    },
    {
        id: 3726, bankId: 42, branchName: "FAR NORTH AREA AFFICE", branchCode: "280376"
    },
    {
        id: 3769, bankId: 42, branchName: "FAR NORTH CASH SERVICE CNTR", branchCode: "281071"
    },
    {
        id: 3749, bankId: 42, branchName: "FINANCE BRANCH NAMIBIA - 554", branchCode: "280672"
    },
    {
        id: 3716, bankId: 42, branchName: "FINANCIAL CONSULTANTS", branchCode: "280274"
    },
    {
        id: 9251, bankId: 42, branchName: "FINTEGRATE", branchCode: "289280"
    },
    {
        id: 3789, bankId: 42, branchName: "FIRST TRUST NAMIBIA - 642", branchCode: "281672"
    },
    {
        id: 3784, bankId: 42, branchName: "FIRSTNAMIB TREASURY", branchCode: "281472"
    },
    {
        id: 3741, bankId: 42, branchName: "FNB AREA OFFICE OTJIWARONGO", branchCode: "280575"
    },
    {
        id: 9248, bankId: 42, branchName: "FNB BUSINESS", branchCode: "289179"
    },
    {
        id: 3743, bankId: 42, branchName: "FNB CARD", branchCode: "280577"
    },
    {
        id: 3762, bankId: 42, branchName: "FNB HOMELOANS NAMIBIA", branchCode: "280871"
    },
    {
        id: 3718, bankId: 42, branchName: "FNB INSURANCE", branchCode: "280276"
    },
    {
        id: 3786, bankId: 42, branchName: "FNB KLIEN WINDHOEK", branchCode: "281479"
    },
    {
        id: 9253, bankId: 42, branchName: "FNB NAMIBIA FLEET", branchCode: "289475"
    },
    {
        id: 3732, bankId: 42, branchName: "FNB NOMINEES NAMIBIA", branchCode: "280474"
    },
    {
        id: 3709, bankId: 42, branchName: "FNB ONGWEDIVA", branchCode: "280180"
    },
    {
        id: 3696, bankId: 42, branchName: "FNB PRIVATE CLIENTS WINDHOEK", branchCode: "280071"
    },
    {
        id: 6193, bankId: 42, branchName: "FNB - THE GROVE", branchCode: "289375"
    },
    {
        id: 9260, bankId: 42, branchName: "FUNDING PORTFOLIO", branchCode: "289976"
    },
    {
        id: 3776, bankId: 42, branchName: "GFCD SYSTEM ACCOUNTING - 640", branchCode: "281172"
    },
    {
        id: 3722, bankId: 42, branchName: "GOBABIS", branchCode: "280372"
    },
    {
        id: 3702, bankId: 42, branchName: "GROOTFONTEIN NAMIBIA - 532", branchCode: "280173"
    },
    {
        id: 3735, bankId: 42, branchName: "GROUP INTERNAL AUDIT", branchCode: "280477"
    },
    {
        id: 9258, bankId: 42, branchName: "GROUP OPERATIONS NAMIBIA", branchCode: "289875"
    },
    {
        id: 3805, bankId: 42, branchName: "H/OFFICE WINDHOEK NAMIBIA - 556", branchCode: "282672"
    },
    {
        id: 3744, bankId: 42, branchName: "HENTIES BAY", branchCode: "280578"
    },
    {
        id: 3757, bankId: 42, branchName: "HUMAN RESOURCES SUPPORT", branchCode: "280772"
    },
    {
        id: 3734, bankId: 42, branchName: "INFORMATION TECHNOLOGY", branchCode: "280476"
    },
    {
        id: 3791, bankId: 42, branchName: "INTERNATIONAL BUSINESS CENTRE", branchCode: "281772"
    },
    {
        id: 3763, bankId: 42, branchName: "JOHN MEINERT STREET - 557", branchCode: "280872"
    },
    {
        id: 3700, bankId: 42, branchName: "KARASBURG NAMIBIA - 534", branchCode: "280171"
    },
    {
        id: 3771, bankId: 42, branchName: "KARIBIB NAMIBIA - 535", branchCode: "281073"
    },
    {
        id: 3733, bankId: 42, branchName: "KATIMA MULILO - 749", branchCode: "280475"
    },
    {
        id: 3751, bankId: 42, branchName: "KATUTURA BRANCH", branchCode: "280674"
    },
    {
        id: 3713, bankId: 42, branchName: "KEETMANSHOOP NAMIBIA - 536", branchCode: "280271"
    },
    {
        id: 9194, bankId: 42, branchName: "KHOMASDAL", branchCode: "289178"
    },
    {
        id: 9193, bankId: 42, branchName: "Kuisebmund", branchCode: "289273"
    },
    {
        id: 3819, bankId: 42, branchName: "LE PLATZ TSUMEB", branchCode: "289174"
    },
    {
        id: 3773, bankId: 42, branchName: "LEGAL & CREDIT RISK", branchCode: "281075"
    },
    {
        id: 3721, bankId: 42, branchName: "LUDERITZ NAMIBIA - 537", branchCode: "280371"
    },
    {
        id: 3801, bankId: 42, branchName: "MAERUA MALL", branchCode: "282273"
    },
    {
        id: 3729, bankId: 42, branchName: "MARIENTAL NAMIBIA - 538", branchCode: "280471"
    },
    {
        id: 3710, bankId: 42, branchName: "MERCHANTACQUIRING NAMIBIA", branchCode: "280181"
    },
    {
        id: 3765, bankId: 42, branchName: "MICRO LOANS WINDHOEK - 641", branchCode: "280971"
    },
    {
        id: 3820, bankId: 42, branchName: "MIDWAY OTJIWARONGO", branchCode: "289175"
    },
    {
        id: 3719, bankId: 42, branchName: "MONDESA BRANCH", branchCode: "280280"
    },
    {
        id: 3727, bankId: 42, branchName: "NAMIBIA UNIT TRU", branchCode: "280377"
    },
    {
        id: 9252, bankId: 42, branchName: "NKURENKURU", branchCode: "289380"
    },
    {
        id: 3754, bankId: 42, branchName: "NORTHERN INDUSTRIAL", branchCode: "280678"
    },
    {
        id: 3723, bankId: 42, branchName: "OKAHANDJA NAMIBIA - 539", branchCode: "280373"
    },
    {
        id: 3760, bankId: 42, branchName: "OKAHAO", branchCode: "280775"
    },
    {
        id: 3724, bankId: 42, branchName: "OKAKARARA", branchCode: "280374"
    },
    {
        id: 3759, bankId: 42, branchName: "OKONGO", branchCode: "280774"
    },
    {
        id: 3778, bankId: 42, branchName: "OLD POWER STATION", branchCode: "281174"
    },
    {
        id: 3731, bankId: 42, branchName: "OMARURU - 540", branchCode: "280473"
    },
    {
        id: 3697, bankId: 42, branchName: "OMUTHIYA", branchCode: "280072"
    },
    {
        id: 3782, bankId: 42, branchName: "ONDANGWA", branchCode: "281373"
    },
    {
        id: 3725, bankId: 42, branchName: "ONE LEGAL", branchCode: "280375"
    },
    {
        id: 3785, bankId: 42, branchName: "OPUWO", branchCode: "281473"
    },
    {
        id: 3748, bankId: 42, branchName: "ORANJEMUND NAMIBIA - 541", branchCode: "280671"
    },
    {
        id: 3783, bankId: 42, branchName: "OSHAKATI GAME", branchCode: "281379"
    },
    {
        id: 3777, bankId: 42, branchName: "OSHAKATI NAMIBIA - 542", branchCode: "281173"
    },
    {
        id: 3705, bankId: 42, branchName: "OSHIKANGO", branchCode: "280176"
    },
    {
        id: 3739, bankId: 42, branchName: "OTAVI NAMIBIA - 543", branchCode: "280573"
    },
    {
        id: 3750, bankId: 42, branchName: "OTJIWARONGO NAMIBIA - 544", branchCode: "280673"
    },
    {
        id: 3790, bankId: 42, branchName: "OUTAPI", branchCode: "281673"
    },
    {
        id: 3758, bankId: 42, branchName: "OUTJO - 545", branchCode: "280773"
    },
    {
        id: 9256, bankId: 42, branchName: "POINTS OF PRESENCE NAMIBIA", branchCode: "289675"
    },
    {
        id: 3752, bankId: 42, branchName: "POST STREET MALL BRANCH", branchCode: "280675"
    },
    {
        id: 9255, bankId: 42, branchName: "PREMISES & INFRASTRUCTURE NAM", branchCode: "289576"
    },
    {
        id: 9254, bankId: 42, branchName: "PROJECT MANAGEMENT OFFICE (PM)", branchCode: "289575"
    },
    {
        id: 3755, bankId: 42, branchName: "PROSPERITA", branchCode: "280679"
    },
    {
        id: 3766, bankId: 42, branchName: "REHOBOTH NAMIBIA - 559", branchCode: "280972"
    },
    {
        id: 3774, bankId: 42, branchName: "RETAIL BANKING SUPPORT", branchCode: "281076"
    },
    {
        id: 9247, bankId: 42, branchName: "RISK & COMPLIANCE", branchCode: "289176"
    },
    {
        id: 3706, bankId: 42, branchName: "ROSH PINAH", branchCode: "280177"
    },
    {
        id: 3780, bankId: 42, branchName: "RUNDU NAMIBIA - 553", branchCode: "281273"
    },
    {
        id: 3800, bankId: 42, branchName: "SME BUSINES UNIT", branchCode: "282272"
    },
    {
        id: 3740, bankId: 42, branchName: "SOUTHERN AREA OFFICE", branchCode: "280574"
    },
    {
        id: 3781, bankId: 42, branchName: "STAFF OTHER NAMBIA - 618", branchCode: "281372"
    },
    {
        id: 3770, bankId: 42, branchName: "STRATEGIC MARKETING & COMMUNIC", branchCode: "281072"
    },
    {
        id: 9250, bankId: 42, branchName: "STRUCTURED FINANCE NAMIBIA", branchCode: "289275"
    },
    {
        id: 3824, bankId: 42, branchName: "SWABOU - WINDHOEK BRANCH", branchCode: "690172"
    },
    {
        id: 3753, bankId: 42, branchName: "SWABOU HOMELOANS", branchCode: "280676"
    },
    {
        id: 3730, bankId: 42, branchName: "SWAKOPMUND NAMIBIA - 546", branchCode: "280472"
    },
    {
        id: 3764, bankId: 42, branchName: "TSUMEB NAMIBIA - 547", branchCode: "280873"
    },
    {
        id: 3767, bankId: 42, branchName: "USAKOS  ( CLOSED )", branchCode: "280973"
    },
    {
        id: 2269, bankId: 42, branchName: "WALVIS BAY C.P. - 510", branchCode: "200572"
    },
    {
        id: 3798, bankId: 42, branchName: "WALVIS BAY NAMIBIA - 510", branchCode: "282172"
    },
    {
        id: 9257, bankId: 42, branchName: "WEALTH SUPPORT CENTRE NAMIBIA", branchCode: "289775"
    },
    {
        id: 3817, bankId: 42, branchName: "WERNHIL BRANCH", branchCode: "289172"
    },
    {
        id: 3796, bankId: 42, branchName: "WESBANK WINDHOEK - 570", branchCode: "282072"
    },
    {
        id: 3737, bankId: 42, branchName: "WINDHOEK ADMIN CENTRE - 533", branchCode: "280571"
    },
    {
        id: 3742, bankId: 42, branchName: "WINDHOEK CENTRAL AREA OFFICE", branchCode: "280576"
    },
    {
        id: 3794, bankId: 42, branchName: "WINDHOEK COMMERCIAL SUITE", branchCode: "281972"
    },
    {
        id: 3793, bankId: 42, branchName: "WINDHOEK CORPORATE SUITE - 568", branchCode: "281872"
    },
    {
        id: 3701, bankId: 42, branchName: "WINDHOEK NAMIBIA - 550", branchCode: "280172"
    }]
},
{
    id: 61, description: "Letshego Bank Namibia Limited", bankBranches: [{
        id: 9204, bankId: 61, branchName: "CENTRAL PROCESSING", branchCode: "881001"
    },
    {
        id: 9280, bankId: 61, branchName: "EENHANA", branchCode: "881012"
    },
    {
        id: 9274, bankId: 61, branchName: "GOBABIS", branchCode: "881006"
    },
    {
        id: 9272, bankId: 61, branchName: "Grootfontein", branchCode: "881004"
    },
    {
        id: 9277, bankId: 61, branchName: "KATIMA MULILO", branchCode: "881009"
    },
    {
        id: 9285, bankId: 61, branchName: "KATUTURA", branchCode: "881021"
    },
    {
        id: 9275, bankId: 61, branchName: "KEETMANSHOOP", branchCode: "881007"
    },
    {
        id: 9281, bankId: 61, branchName: "OKAHANDJA", branchCode: "881013"
    },
    {
        id: 9279, bankId: 61, branchName: "ONDANGWA", branchCode: "881011"
    },
    {
        id: 9276, bankId: 61, branchName: "OPUWO", branchCode: "881008"
    },
    {
        id: 9278, bankId: 61, branchName: "OSHAKATI", branchCode: "881010"
    },
    {
        id: 9271, bankId: 61, branchName: "OTJIWARONGO", branchCode: "881003"
    },
    {
        id: 9283, bankId: 61, branchName: "OUTAPI", branchCode: "881015"
    },
    {
        id: 9284, bankId: 61, branchName: "RUNDU", branchCode: "881016"
    },
    {
        id: 9282, bankId: 61, branchName: "SWAKOPMUND", branchCode: "881014"
    },
    {
        id: 9273, bankId: 61, branchName: "TSUMEB", branchCode: "881005"
    },
    {
        id: 9270, bankId: 61, branchName: "WALVISBAY", branchCode: "881002"
    },
    {
        id: 9286, bankId: 61, branchName: "WINDHOEK", branchCode: "881022"
    }]
},
{
    id: 18, description: "Nedbank Namibia", bankBranches: [{
        id: 5903, bankId: 18, branchName: "BUSSINESS CENTRE", branchCode: "461617"
    },
    {
        id: 5869, bankId: 18, branchName: "C B O N  KEETMANSHOOP", branchCode: "161171"
    },
    {
        id: 5868, bankId: 18, branchName: "C B O N LUDERITZ", branchCode: "161071"
    },
    {
        id: 5870, bankId: 18, branchName: "CBON PROCESSING", branchCode: "161372"
    },
    {
        id: 5861, bankId: 18, branchName: "CBON SWAKOPMUND", branchCode: "105272"
    },
    {
        id: 5863, bankId: 18, branchName: "CBON WALVIS BAY", branchCode: "107272"
    },
    {
        id: 5875, bankId: 18, branchName: "CBON WINDHOEK SOUTH", branchCode: "162972"
    },
    {
        id: 5909, bankId: 18, branchName: "CENTRALISED SERVICES", branchCode: "461706"
    },
    {
        id: 5876, bankId: 18, branchName: "COMBANK OSHAKATI", branchCode: "169473"
    },
    {
        id: 5872, bankId: 18, branchName: "COMBANK TREASURY", branchCode: "161572"
    },
    {
        id: 5877, bankId: 18, branchName: "COMMBANK HIDAS PARK AGENCY", branchCode: "169672"
    },
    {
        id: 5862, bankId: 18, branchName: "COMMBANK NAMIBIA WERNHILL", branchCode: "105472"
    },
    {
        id: 9262, bankId: 18, branchName: "DUNES MALL", branchCode: "461031"
    },
    {
        id: 5887, bankId: 18, branchName: "EENHANA", branchCode: "461075"
    },
    {
        id: 5900, bankId: 18, branchName: "FINANCE", branchCode: "461614"
    },
    {
        id: 5866, bankId: 18, branchName: "FINANCE IN EDUCATION (PTY) LTD", branchCode: "150572"
    },
    {
        id: 9263, bankId: 18, branchName: "GOBABIS", branchCode: "461032"
    },
    {
        id: 5889, bankId: 18, branchName: "GROOTFONTEIN", branchCode: "461077"
    },
    {
        id: 5895, bankId: 18, branchName: "GROUP RISK", branchCode: "461600"
    },
    {
        id: 5871, bankId: 18, branchName: "H.OFFICE ACCOUNTING CBON", branchCode: "161472"
    },
    {
        id: 5908, bankId: 18, branchName: "HIDAS AGENCY", branchCode: "461696"
    },
    {
        id: 5881, bankId: 18, branchName: "HUMAN RESOURCES", branchCode: "461040"
    },
    {
        id: 5859, bankId: 18, branchName: "INDEP AVE WINDHOEK", branchCode: "103872"
    },
    {
        id: 5880, bankId: 18, branchName: "INDEPENDENCE", branchCode: "461038"
    },
    {
        id: 5906, bankId: 18, branchName: "INTERNAL AUDIT", branchCode: "461678"
    },
    {
        id: 5902, bankId: 18, branchName: "INTERNATIONAL", branchCode: "461616"
    },
    {
        id: 5888, bankId: 18, branchName: "KATIMA MULILO", branchCode: "461076"
    },
    {
        id: 5865, bankId: 18, branchName: "KATUTURA", branchCode: "461001"
    },
    {
        id: 5898, bankId: 18, branchName: "KEETMANSHOOP", branchCode: "461611"
    },
    {
        id: 5886, bankId: 18, branchName: "KUISEBMOND", branchCode: "461073"
    },
    {
        id: 5897, bankId: 18, branchName: "LUDERITZ", branchCode: "461610"
    },
    {
        id: 5882, bankId: 18, branchName: "MAERUA MALL", branchCode: "461041"
    },
    {
        id: 5867, bankId: 18, branchName: "MAIN BRANCH", branchCode: "160972"
    },
    {
        id: 5896, bankId: 18, branchName: "MAIN BRANCH", branchCode: "461609"
    },
    {
        id: 5905, bankId: 18, branchName: "MANAGING DIRECTORATE", branchCode: "461654"
    },
    {
        id: 5874, bankId: 18, branchName: "NEDBANK NAMIBIA CORPORATE", branchCode: "161772"
    },
    {
        id: 5873, bankId: 18, branchName: "NEDBANK NAMIBIA INTERNATIONAL", branchCode: "161672"
    },
    {
        id: 5860, bankId: 18, branchName: "NEDBANK NAMIBIA PERSONNEL", branchCode: "104072"
    },
    {
        id: 5864, bankId: 18, branchName: "NEDBANK ONDANGWA", branchCode: "112505"
    },
    {
        id: 9198, bankId: 18, branchName: "NEDBANK TSUMEB", branchCode: "461028"
    },
    {
        id: 9264, bankId: 18, branchName: "Nedbank Wealth", branchCode: "461090"
    },
    {
        id: 6195, bankId: 18, branchName: "NEDBANK-ONGWEDIVA", branchCode: "461034"
    },
    {
        id: 9265, bankId: 18, branchName: "NEDLOANS", branchCode: "461572"
    },
    {
        id: 5879, bankId: 18, branchName: "NORTHERN INDUSTRIAL", branchCode: "461002"
    },
    {
        id: 6197, bankId: 18, branchName: "OKAHANDJA", branchCode: "461035"
    },
    {
        id: 5893, bankId: 18, branchName: "ONDANGWA", branchCode: "461125"
    },
    {
        id: 5907, bankId: 18, branchName: "OSHAKATI", branchCode: "461694"
    },
    {
        id: 5894, bankId: 18, branchName: "OSHIKANGO", branchCode: "461126"
    },
    {
        id: 9196, bankId: 18, branchName: "OTJIWARONGO", branchCode: "461071"
    },
    {
        id: 5892, bankId: 18, branchName: "PRIVATE BANKING", branchCode: "461089"
    },
    {
        id: 5899, bankId: 18, branchName: "PROCESSING", branchCode: "461613"
    },
    {
        id: 9199, bankId: 18, branchName: "PROSPERITA", branchCode: "461036"
    },
    {
        id: 9200, bankId: 18, branchName: "REHOBOTH", branchCode: "461027"
    },
    {
        id: 5890, bankId: 18, branchName: "RUNDU", branchCode: "461078"
    },
    {
        id: 5883, bankId: 18, branchName: "SWAKOPMUND", branchCode: "461052"
    },
    {
        id: 6192, bankId: 18, branchName: "THE GROVE", branchCode: "461030"
    },
    {
        id: 5901, bankId: 18, branchName: "TREASURY", branchCode: "461615"
    },
    {
        id: 5891, bankId: 18, branchName: "UUTAPI", branchCode: "461079"
    },
    {
        id: 5885, bankId: 18, branchName: "WALVISBAY", branchCode: "461072"
    },
    {
        id: 5884, bankId: 18, branchName: "WERNHILL AGENCY", branchCode: "461054"
    },
    {
        id: 6196, bankId: 18, branchName: "WESTLANE", branchCode: "461029"
    },
    {
        id: 5904, bankId: 18, branchName: "WINDHOEK SOUTH", branchCode: "461629"
    }]
},
{
    id: 3, description: "Standard Bank Namibia", bankBranches: [{
        id: 9227, bankId: 3, branchName: "ACCOUNTING", branchCode: "083172"
    },
    {
        id: 9206, bankId: 3, branchName: "ARANOS", branchCode: "080071"
    },
    {
        id: 9240, bankId: 3, branchName: "AUSPANNPLATZ CASH CENTRE", branchCode: "086072"
    },
    {
        id: 9223, bankId: 3, branchName: "AUSSPANNPLATZ", branchCode: "082672"
    },
    {
        id: 9215, bankId: 3, branchName: "BA21 BRANCH", branchCode: "081111"
    },
    {
        id: 9207, bankId: 3, branchName: "BETHANIE AGENCY", branchCode: "080171"
    },
    {
        id: 9197, bankId: 3, branchName: "Eenhana", branchCode: "087072"
    },
    {
        id: 9218, bankId: 3, branchName: "GOBABIS", branchCode: "082072"
    },
    {
        id: 9229, bankId: 3, branchName: "GROOTFONTEIN", branchCode: "084073"
    },
    {
        id: 9224, bankId: 3, branchName: "GUSTAV VOIGTS CENTRE", branchCode: "082772"
    },
    {
        id: 9212, bankId: 3, branchName: "KATIMA MULILO", branchCode: "080672"
    },
    {
        id: 9225, bankId: 3, branchName: "KATUTURA", branchCode: "082972"
    },
    {
        id: 9208, bankId: 3, branchName: "KEETMANSHOOP", branchCode: "080371"
    },
    {
        id: 9209, bankId: 3, branchName: "LUDERITZ", branchCode: "080471"
    },
    {
        id: 9242, bankId: 3, branchName: "MAERUA MALL", branchCode: "086872"
    },
    {
        id: 9210, bankId: 3, branchName: "MALTAHOHE AGENCY", branchCode: "080571"
    },
    {
        id: 9211, bankId: 3, branchName: "MARIENTAL", branchCode: "080671"
    },
    {
        id: 9230, bankId: 3, branchName: "OKAHANDJA", branchCode: "084273"
    },
    {
        id: 9231, bankId: 3, branchName: "OMARURU", branchCode: "084373"
    },
    {
        id: 9205, bankId: 3, branchName: "ONDANGWA", branchCode: "005972"
    },
    {
        id: 9216, bankId: 3, branchName: "ONGWEDIVA", branchCode: "081171"
    },
    {
        id: 9203, bankId: 3, branchName: "Opuwo", branchCode: "087172"
    },
    {
        id: 9236, bankId: 3, branchName: "OSHAKATI", branchCode: "084873"
    },
    {
        id: 9217, bankId: 3, branchName: "OSHANA BRANCH", branchCode: "081771"
    },
    {
        id: 9241, bankId: 3, branchName: "OSHIKANGO", branchCode: "086572"
    },
    {
        id: 9232, bankId: 3, branchName: "OTAVI AGENCY", branchCode: "084473"
    },
    {
        id: 9233, bankId: 3, branchName: "OTJIWARONGO", branchCode: "084573"
    },
    {
        id: 9234, bankId: 3, branchName: "OUTJO", branchCode: "084673"
    },
    {
        id: 9213, bankId: 3, branchName: "REHOBOTH", branchCode: "080871"
    },
    {
        id: 9214, bankId: 3, branchName: "ROSH PINAH", branchCode: "080971"
    },
    {
        id: 9239, bankId: 3, branchName: "RUNDU", branchCode: "085173"
    },
    {
        id: 9226, bankId: 3, branchName: "STANNIC DIVISION", branchCode: "083072"
    },
    {
        id: 9219, bankId: 3, branchName: "SWAKOPMUND", branchCode: "082172"
    },
    {
        id: 9222, bankId: 3, branchName: "TRUSTEE", branchCode: "082572"
    },
    {
        id: 9238, bankId: 3, branchName: "TRUSTEE BRANCH", branchCode: "085172"
    },
    {
        id: 9235, bankId: 3, branchName: "TSUMEB", branchCode: "084773"
    },
    {
        id: 6182, bankId: 3, branchName: "Universal Branch", branchCode: "087373"
    },
    {
        id: 9220, bankId: 3, branchName: "WALVIS BAY", branchCode: "082272"
    },
    {
        id: 9221, bankId: 3, branchName: "WINDHOEK", branchCode: "082372"
    },
    {
        id: 9237, bankId: 3, branchName: "WINDHOEK IBC", branchCode: "085073"
    },
    {
        id: 9228, bankId: 3, branchName: "WINDHOEK OPERATIONS PROC CENT", branchCode: "084072"
    },
    {
        id: 865, bankId: 3, branchName: "WINDHOEK SWABANK SPONSOR BRNCH", branchCode: "82472"
    }]
},
{
    id: 63, description: "Trustco Bank Namibia", bankBranches: [{
        id: 9287, bankId: 63, branchName: "TBN UNIVERSAL BRANCH", branchCode: "883000"
    }]
},]